import { useState, useEffect } from 'react';
import { SellerSettingsPage } from './seller/SellerSettingsPage';
import { DesktopSellerSettingsPage } from './desktop/DesktopSellerSettingsPage';

export function ResponsiveSellerSettingsPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerSettingsPage /> : <DesktopSellerSettingsPage />;
}